import MolhamButton from "components/ReuseableCompos/MolhamButton";
import useTranslation from "next-translate/useTranslation";
import Image from "next/image";

type Props = {
  image: string;
  pdf: string;
  year: number;
  mWidth?: number;
};

function AnnualReportCard({ image, pdf, year, mWidth = 400 }: Props) {
  const { t } = useTranslation();
  return (
    <div
      className="d-flex flex-column rounded border mb-3 cursor"
      style={{ maxWidth: mWidth }}
      onClick={() => window.open(pdf, "_blank")}
    >
      <Image
        src={image}
        alt="Picture of the author"
        style={{
          borderTopLeftRadius: "0.75rem",
          borderTopRightRadius: "0.75rem",
          objectFit: "cover",
        }}
        unoptimized
        width={400}
        height={400}
        className="w-100"
      />
      <div className="d-flex flex-column">
        <span className="fw-bold fs-xxl p-3">
          {t("annual_report", {
            year,
          })}
        </span>
        <div className="v-centered justify-content-between w-100 border-top p-3">
          <MolhamButton
            id={"annual-report-" + year + "-view"}
            label={t("view")}
            style={{ minWidth: 120 }}
            onClick={() => window.open(pdf, "_blank")}
          />
          <a
            href={pdf}
            download
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <MolhamButton
              id={"annual-report-" + year + "-download"}
              variant="outline-primary"
              onHoverVariant="primary"
              // className="text-white"
              label={t("download")}
              style={{ minWidth: 120 }}
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default AnnualReportCard;
